import { Box, IconButton } from '@mui/material';
import { FaChevronLeft, FaChevronRight, FaBackwardStep, FaForwardStep } from "react-icons/fa6";

function Pagination({ count = 1, page = 1, onChange }) {

  const updatePage = (newPage) => {
    if (newPage < 1 || newPage > count) return;
    onChange?.(null, newPage); // 👈 MUI-compatible
  };

  const btnStyle = (isActive) => ({
    p: 1,
    color: isActive ? '#FFCC33' : '#D9D9D9',
    transition: '0.3s',
    fontSize: '16px',
    '&:hover': { color: '#FFCC33' }
  });

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>

      {/* First */}
      <IconButton
        disabled={page === 1}
        sx={btnStyle(page !== 1)}
        onClick={() => updatePage(1)}
      >
        <FaBackwardStep />
      </IconButton>

      {/* Prev */}
      <IconButton
        disabled={page === 1}
        sx={btnStyle(page !== 1)}
        onClick={() => updatePage(page - 1)}
      >
        <FaChevronLeft />
      </IconButton>

      {/* Page indicator */}
      <Box className="text" sx={{ fontWeight: 500 }}>
        {String(page).padStart(2, '0')} / {String(count).padStart(2, '0')}
      </Box>

      {/* Next */}
      <IconButton
        disabled={page === count}
        sx={btnStyle(page !== count)}
        onClick={() => updatePage(page + 1)}
      >
        <FaChevronRight />
      </IconButton>

      {/* Last */}
      <IconButton
        disabled={page === count}
        sx={btnStyle(page !== count)}
        onClick={() => updatePage(count)}
      >
        <FaForwardStep />
      </IconButton>

    </Box>
  );
}

export default Pagination;
